// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll-top[data-v-055d4f82] {\n  right: 50px;\n  bottom: 10px;\n}\n@media only screen and (max-width: 1600px) {\n.scroll-top[data-v-055d4f82] {\n    right: 15px;\n    bottom: 10px;\n}\n}", ""]);
// Exports
module.exports = exports;
